import { render } from "./PrepareReceptionModal.vue?vue&type=template&id=ac4a79a8"
import script from "./PrepareReceptionModal.vue?vue&type=script&lang=js"
export * from "./PrepareReceptionModal.vue?vue&type=script&lang=js"

import "./PrepareReceptionModal.vue?vue&type=style&index=0&id=ac4a79a8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__